import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const FinalCTA = () => {
    return (
        <section
            id="cta"
            className="relative py-28 lg:py-40 overflow-hidden"
            data-testid="cta-section"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.8 }}
                    className="relative rounded-[40px] overflow-hidden border border-white/10 px-8 py-20 md:p-20 lg:p-28"
                    style={{
                        background:
                            "radial-gradient(ellipse at 30% 20%, rgba(121, 30, 226, 0.5) 0%, transparent 55%), radial-gradient(ellipse at 80% 80%, rgba(245, 72, 21, 0.35) 0%, transparent 55%), #0a0436",
                    }}
                >
                    <div className="absolute inset-0 noise pointer-events-none" />

                    {/* Animated equalizer accent */}
                    <div className="absolute top-10 right-10 hidden md:flex items-end gap-1 opacity-50">
                        {[10, 24, 16, 32, 20, 28, 14].map((h, i) => (
                            <span
                                key={i}
                                className="w-1 bg-white rounded-full eq-bar"
                                style={{
                                    height: `${h * 2}px`,
                                    animationDelay: `${i * 0.12}s`,
                                }}
                            />
                        ))}
                    </div>

                    <div className="relative max-w-4xl">
                        <p className="text-sm uppercase tracking-[0.3em] text-white/70 mb-6 font-medium">
                            Amplify your voice
                        </p>
                        <h2
                            className="font-heading text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-tighter leading-[0.95] text-white mb-8"
                            data-testid="cta-heading"
                        >
                            Start your journey
                            <br />
                            with Maajja.
                        </h2>
                        <p className="text-lg md:text-xl text-white/75 max-w-2xl mb-12 font-body leading-relaxed">
                            Join the next wave of independent artists rewriting
                            the rules of the music industry. It takes 2 minutes
                            to upload your first release.
                        </p>

                        <div className="flex flex-col sm:flex-row gap-4">
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                window.dispatchEvent(new CustomEvent("maajja:join"));
                            }}
                            className="group inline-flex items-center justify-center gap-2 bg-white hover:bg-white/90 text-[#030023] px-10 py-5 rounded-full font-bold text-lg transition-all hover:shadow-[0_0_60px_rgba(255,255,255,0.4)] active:scale-95"
                            data-testid="final-cta-primary"
                        >
                            Join Maajja — it's free
                            <ArrowRight
                                size={20}
                                className="transition-transform group-hover:translate-x-1"
                            />
                        </a>
                            <a
                                href="#"
                                className="inline-flex items-center justify-center gap-2 border border-white/30 hover:border-white text-white px-10 py-5 rounded-full font-semibold text-lg transition-all backdrop-blur-md hover:bg-white/10 active:scale-95"
                                data-testid="final-cta-secondary"
                            >
                                Book a demo
                            </a>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};
